import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/oms.png'
import IMG2 from '../../assets/ldapp.png'
import IMG3 from '../../assets/uinchrist1.png'
import IMG4 from '../../assets/cctor.png'
import IMG5 from '../../assets/namodent.png'
import IMG6 from '../../assets/ccbcnp.png'
import IMG7 from '../../assets/hotelmenuhaa.png'
import IMG8 from '../../assets/port4.png'
import IMG9 from '../../assets/port6.png'

const data = [
  {
    id: 1,
    image: IMG1,
    title: 'Office Management System',
    description: 'A full-featured enterprise system for managing employees, payroll, attendance, and leave workflows.',
    tech: 'Laravel, PHP, MySQL, JavaScript, Bootstrap & HTML/CSS',
    role: 'Full Stack Developer',
    github: 'https://gitlab.com/Ajays9733/evss-oms',
    demo: 'https://oms.evlaveiasoftwareservices.com/'
  },
  {
    id: 2,
    image: IMG2,
    title: 'Compass',
    description: 'Enterprise accounting and budget control system built for managing university construction projects, financial tracking, and encumbrances.',
    tech: 'ColdFusion, MSSQL, PHP, HTML/CSS, Bootstrap, Windows Server, Ajax/jQuery',
    role: 'Full Stack Developer',
    github: 'https://github.com',
    demo: 'https://ldappdev.com/pdc/index.php'
  },
  {
    id: 3,
    image: IMG3,
    title: 'United In Christ',
    description: 'A community-driven Christian social platform where users can connect, share blogs, post prayers, and engage in faith-based discussions.',
    tech: 'Laravel, PHP, MySQL, JavaScript, Bootstrap & HTML/CSS',
    role: 'Full Stack Developer',
    github: 'https://github.com',
    demo: 'https://uinchrist.com/'
  },
  {
    id: 4,
    image: IMG4,
    title: 'Calvary Chapel Toronto',
    description: 'A dynamic content management web application built for Calvary Chapel Toronto to manage sermons, events, media content, and announcements.',
    tech: 'Laravel, PHP, JavaScript, Bootstrap & HTML/CSS',
    role: 'Full Stack Developer',
    github: 'https://github.com',
    demo: 'https://cctorem.com/'
  },
  {
    id: 5,
    image: IMG5,
    title: 'Namo Dental',
    description: 'A dynamic content management web application built for Namo Dental To manage the appointment and clinic informations.',
    tech: 'PHP, JavaScript, Bootstrap, HTML/CSS',
    role: 'Backend Developer',
    github: 'https://github.com',
    demo: 'https://namodental.com/'
  },
  {
    id: 6,
    image: IMG6,
    title: 'Calvary Chapel Bible College Nepal',
    description: 'A dynamic content management web application built for Calvary Chapel Bible College to manage events, media content, announcements and admissions.',
    tech: 'Laravel, PHP, JavaScript/jQuery, Bootstrap & HTML/CSS',
    role: 'Full Stack Developer',
    github: 'https://github.com',
    demo: 'https://ccbcnp.com/'
  },
  {
    id: 7,
    image: IMG7,
    title: 'Hotel Menuha',
    description: 'A dynamic content management web application built for managing hotel information, services, room details, and announcements.',
    tech: 'Laravel, PHP, JavaScript/jQuery, Bootstrap & HTML/CSS',
    role: 'Full Stack Developer',
    github: 'https://hotelmenuha.com/',
    demo: 'https://hotelmenuha.com/'
  },
  {
    id: 8,
    image: IMG8,
    title: 'LADIMS',
    description: 'Enterprise system for managing inventory and accounting.',
    tech: 'PHP, Codeigniter, MySQL, Bootstrap, HTML/CSS, Jquery',
    role: 'Full Stack Developer',
    github: 'https://gitlab.com/Raju979/ims_lucid',
    demo: 'http://2ezze.com/'
  },
  {
    id: 9,
    image: IMG9,
    title: 'Byappar',
    github: 'https://github.com',
    description: 'Enterprise system for managing inventory and accounting.',
    tech: 'PHP, Codeigniter, MySQL, Bootstrap, HTML/CSS, Jquery',
    role: 'Full Stack Developer',
    demo: 'http://inventory.byappar.com/'
  },
]
const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Works</h5>
      <h2>My Portfolio</h2>

      <div className="container portfolio__container">
        {
          data.map(({ id, image, title,description,tech,role, github, demo }) => {
            return (
              <article key={id} className='portfolio__item'>
                <div className="portfolio__item-image">
                  <img src={image} alt={title} />
                </div>

                <h3>{title}</h3>

                <p className="portfolio__description">{description}</p>

                <small className="portfolio__tech">
                  <strong>Tech:</strong> {tech}
                </small>

                <small className="portfolio__role">
                  <strong>Role:</strong> {role}
                </small>

                <div className="portfolio__item-cta">
                  {/* {github && (
                    <a href={github} target='_blank' rel="noopener noreferrer" className='btn'>
                      GitHub
                    </a>
                  )} */}

                  {demo && id < 8 && (
                    <a href={demo} target='_blank' rel="noopener noreferrer" className='btn btn-primary'>
                      Live Demo
                    </a>
                  )}
                </div>
              </article>
            )
          }

          )
        }

      </div>

    </section>
  )
}

export default Portfolio